import { useSessionStorage } from "usehooks-ts";

import { getChatbotSessionKey } from "@virtual-brain-lib/utils-common";

export const useChatbotSessionStorage = ({
	chatbotId,
	isPreview,
}: {
	chatbotId: string;
	isPreview: boolean;
}) => {
	const [sessionId, setSessionId] = useSessionStorage<string>(
		getChatbotSessionKey({ chatbotId, isPreview }),
		"", // default value
		// we override serializer / deserialize to avoid internal JSON.parse
		{
			serializer: (x) => x,
			deserializer: (x) => x,
		},
	);

	return {
		sessionId,
		setSessionId,
	};
};
